import React, { useEffect, useMemo, useState } from "react";

import {
  updateMedicalHistory,
  updateSiteHistory,
} from "app/_services/UserManagement/EmployeeService";
import { Modal, Button } from "react-bootstrap";

import toastr from "toastr";
import SearchBootstrapTable from "app/Components/BootstrapTable/SearchBootstrapTable";
import CustomTooltip from "app/Components/CommanComponents/CustomTooltip";
import { FiEdit3 } from "react-icons/fi";
import { medicalHistoryValidation } from "../Constant";
import EmployeeMedicalHistoryForm from "./EmployeeMedicalHistoryForm";

function MedicalHistoryList({
  data,
  getFormData,
  siteList,
  onListHistory,
  searchFlag,
  isNoPagination,
}) {
  const [siteHistoryList, setSiteHistoryList] = useState([]);

  // Edit Site History Modal
  const [editHistory, setEditHistory] = useState(false);
  const [selectedHistory, setSelectedHistory] = useState(null);
  const [historyError, setHistoryError] = useState({});

  /******************* Site History Modal**********************/
  const onClickEditHistory = (row) => {
    setEditHistory(true);
    setSelectedHistory({
      ...row,
      siteId: row.siteId || "",
      startDate: row.startDate || "",
      endDate: row.endDate || "",
      effectiveDate: row?.startDate,
      smeCategory: row?.specialMedicalExamCategory,
    });
  };

  const onHideSiteHistory = () => {
    setSiteHistoryList([]);
  };

  const siteHistoryColumns = useMemo(
    () => [
      {
        dataField: "sid",
        text: "S.No.",
        sort: true,
      },
      {
        dataField: "specialMedicalExamCategoryName",
        text: "Special Medical Exam Category",
        sort: true,
      },

      {
        dataField: "specialMedicalExamEligibility",
        text: "Special Medical Exam Eligibility",
        sort: true,
      },
      {
        dataField: "createdAtView",
        text: "Date",
        sort: true,
      },
      {
        dataField: "medicalDueDateView",
        text: "Medical Due Date",
        sort: true,
      },
      {
        dataField: "medicalStatusView",
        text: "Medical Status",
        sort: true,
      },
      {
        dataField: "create",
        text: "Action",
        formatter: (rowContent, row) => {
          console.log("siteHistoryList", siteHistoryList);
          if (
            Array.isArray(siteHistoryList) &&
            siteHistoryList.length > 0 &&
            row.id === siteHistoryList[0].id &&
            row.editFlag
          ) {
            return (
              <div className="actionIconsGroup">
                <CustomTooltip tooltip="Edit">
                  <span
                    onClick={() => onClickEditHistory(row)}
                    className="icons btn-icon font-20 text-cyanBlue"
                  >
                    <FiEdit3 />
                  </span>
                </CustomTooltip>
              </div>
            );
          }
        },
      },
    ],
    [siteHistoryList]
  );

  /******************* Add Site  Modal******************/
  const onChangeHistory = ({ target: { name, value, type, checked } }) => {
    setSelectedHistory((prev) => ({
      ...prev,

      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const onHideHistory = () => {
    setEditHistory(false);
    setSelectedHistory(null);
  };

  const onSubmitEditHistory = async (e) => {
    e.preventDefault();
    let errorObj = medicalHistoryValidation(selectedHistory);
    setHistoryError(errorObj);

    if (Object.values(errorObj).filter((d) => d !== "").length) return;

    let response = await updateMedicalHistory({
      id: selectedHistory.id,
      smeCategory: selectedHistory.smeCategory,
      newMedicalEligibility: selectedHistory.specialMedicalExamEligibility,
      effectiveDate: selectedHistory?.effectiveDate,
    });

    if (!response?.status) return toastr.error(response?.message);

    toastr.success(response.message || "Success.");
    onHideHistory();
    onHideSiteHistory();
    if (getFormData) getFormData();
  };

  /************** useMemo ***************/
  useEffect(() => {
    if (!Array.isArray(data)) return;
    setSiteHistoryList(JSON.parse(JSON.stringify(data)));
  }, [data]);

  return (
    <div>
      {/* Site History */}
      <div className="mt-2 mb-4">
        {!onListHistory && <h5>History</h5>}

        <SearchBootstrapTable
          tableName={"site-history"}
          data={siteHistoryList}
          columns={siteHistoryColumns?.filter(
            (d) => d.dataField !== "create" || !onListHistory
          )}
          tableDownloadFlag={false}
          searchFlag={searchFlag}
          isNoPagination={isNoPagination}
        />
      </div>

      {/* Edit Site History Modal */}
      <Modal show={editHistory} onHide={onHideHistory} backdrop="static" keyboard={false}>
        <Modal.Header closeButton>
          <Modal.Title>Edit History</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <EmployeeMedicalHistoryForm
            siteList={siteList}
            form={selectedHistory}
            onChange={onChangeHistory}
            error={historyError}
          />
        </Modal.Body>

        <Modal.Footer className="justify-content-center">
          <div>
            <Button variant="secondary" onClick={() => onHideHistory()}>
              Back
            </Button>
            <Button className="ml-2" onClick={onSubmitEditHistory} variant="primary">
              Update
            </Button>
          </div>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default MedicalHistoryList;
